// extracted by mini-css-extract-plugin
export default {"tooltip":"PJFAC3J6M3oI9fW864Dd","labelText":"QC8xVe181brUCn8RcgYS","learnMore":"lkpBrY2900sVepvYv8Hi"};